export var Column = function (props) { return null; };
